import { get, merge } from 'lodash';
import moulages from '../../config/moulages';
import makeMoulageLabel from '../../utils/makeMoulageLabel';

function validateMoulages(caseConf) {
  const errors = [];

  const positionState = caseConf._initialStates.find(state => state.id === 'position');
  const startingPosition = get(positionState, 'options.value');
  const caseMoulages = merge({}, caseConf.moulages, caseConf.structuralMoulages);

  // Stance
  for (const [location, moulageKey] of Object.entries(caseMoulages)) {
    const moulage = moulages.find(m => m.key === moulageKey);
    if (!moulage) {
      continue;
    }

    if (moulage.stanceRestrictions) {
      // Starting Position
      if (isStanceRestricted(moulage, location, startingPosition)) {
        errors.push(positionError(`${makeMoulageLabel(moulage.key)} is not compatible with starting position`));
      }
    }
  }

  return {
    errors,
    warnings: [],
  };
}

function isStanceRestricted(moulage, location, position) {
  return get(moulage.stanceRestrictions, location, []).includes(position) ||
         get(moulage.stanceRestrictions, 'ANY', []).includes(position);
}

function positionError(message) {
  return {
    message,
    category: 'patientConditions',
    field: '_intialStates',
    id: 'position',
    metadata: {
      scope: 'control'
    }
  };
}

export default validateMoulages;